<template>
  <div>
    <!-- Popup Modal -->
    <pl-dialog
      :title="'Join RoundTable'"
      size="dessassociate_sequence_roundtable"
      class="text-sm font-semibold text-gray-700"
      :disableOutsideClick="true"
      @close="closeModal"
    >
      <div class="h-full w-full overflow-y-auto py-4">
        <div class="flex flex-col h-full">
          <div class="overflow-y-auto h-full px-5">
            <div>
              Your teacher will give you a code to join in a RoundTable! 
            </div>
          </div>
          <div class="flex flex-col px-5 flex-grow h-full">
            <div class="flex flex-col w-full space-y-1.5 mb-2">
              <span>Enter <span class="underline">RoundTable</span> code</span>
              <input 
                v-model="invite_code" 
                placeholder="Enter the code that was provided by the teacher..." 
                type="text" 
                class="py-2 px-3 w-full border border-solid border-gray-200 bg-white rounded-md focus-within:border-primary"
              />
            </div>
            <div class="flex items-center space-x-2">
              <button @click="closeModal()" class="bg-gray-100 py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200">
                <span>Cancel</span>
              </button>
              <button @click="joinRoundtable" class="bg-primary py-2 flex items-center justify-center space-x-2 text-white font-semibold w-full rounded-md border border-solid border-primary">
                <span>Join RoundTable</span>
                <div v-if="is_joining === true" class="loader"></div>
              </button>
            </div>
            
          </div>
        </div>
      </div>
    </pl-dialog>
  </div>
</template>

<script>
  import Vue from 'vue';
  export default Vue.extend({
    data() {
      return {
        invite_code: '',
        is_joining: false,
      };
    },
    methods: {
      closeModal: function() {
        this.$emit('modalClosed');
      },
      joinRoundtable: function() {
        this.is_joining = true;
        this.$store.dispatch('analytics', 'join course - student joins via join code');
        this.$emit('joinRoundtable', { invite_code: this.invite_code });
      },
    },
  });
</script>
<style scoped>
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-left: 12px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// joinRoundtableModal.vue?75060fd1